import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  ThumbUpOffAlt,
  ThumbDownOffAlt,
  Comment,
  LiveHelp,
  QuestionAnswer,
  PersonAdd,
  Redeem,
  EmojiEvents,
  Reply,
} from '@mui/icons-material';
import { Notification } from '../../../../types';
import { getMetaData } from '../../../../tool';
import useNotificationComponentStyles from './useNotificationComponentStyles';
import useLayoutStyles from '../../../layout/useLayoutStyles';
import useGlobalStyles from '../../../useGlobalStyles';
import { currentUserSelector } from '../../../../redux/slices/userSlice';
import { useAppSelector } from '../../../../redux/hooks';

interface NotificationComponentProps {
  notification: Notification;
}
// TODO: In the future add functionality to click on the notification and go to the post... once we implement users we can do this...

/**
 * NotificationsPage component renders a page displaying personal and follower notifications
 * based on selected tabs.
 */
const NotificationComponent = (props: NotificationComponentProps) => {
  const { classes } = useNotificationComponentStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();
  const { notification } = props;
  const user = useAppSelector(currentUserSelector);

  const navigate = useNavigate();

  const processMessage = (message: string) => {
    let newMessage = message?.replace('{sender}', notification.sender?.username || 'Deleted User');
    newMessage = newMessage?.replace(
      '{receiver}',
      notification.receiver?.username || 'Deleted User',
    );
    return newMessage;
  };

  const renderIcon = (iconType: string) => {
    switch (iconType) {
      case 'upvote':
        return <ThumbUpOffAlt fontSize='large' />;
      case 'downvote':
        return <ThumbDownOffAlt fontSize='large' />;
      case 'comment':
        return <Comment fontSize='large' />;
      case 'question':
        return <LiveHelp fontSize='large' />;
      case 'answer':
        return <QuestionAnswer fontSize='large' />;
      case 'follow':
        return <PersonAdd fontSize='large' />;
      case 'award':
        return <Redeem fontSize='large' />;
      case 'achievement':
        return <EmojiEvents fontSize='large' />;
      case 'reply':
        return <Reply fontSize='large' />;
      default:
        return <div />;
    }
  };

  const processNotificationPath = (path: string) => {
    const sender = notification.sender ? notification.sender.username : user?.username || ''; // If the sender is deleted, use the current user
    const reciever = notification.receiver ? notification.receiver.username : user?.username || ''; // If the receiver is deleted, use the current user
    let newPath = path.replace('{sender}', sender);
    newPath = newPath.replace('{receiver}', reciever);
    return newPath;
  };

  const handleRedirect = () => {
    const updatedPath = processNotificationPath(notification.path);
    navigate(updatedPath);
  };
  const processedMessage = processMessage(notification.message);

  return (
    <>
      <div className={`${classes.notification} ${layoutClasses.rightPadding}`}>
        <Box className={`${classes.notificationIcon}`}>
          {renderIcon(notification.notificationType)}
        </Box>
        <Box>
          <Box className={`${classes.notificationText} ${globalClasses.h6}`}>
            {processedMessage}
          </Box>
          <Box className={`${classes.notificationMeta} ${globalClasses.p}`}>
            {getMetaData(new Date(notification.notificationDateTime))} |{' '}
            <a className={classes.linkStyle} onClick={handleRedirect}>
              View
            </a>
          </Box>
        </Box>
      </div>
    </>
  );
};

export default NotificationComponent;
